import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulseIcon, ShieldCheckIcon, AwardIcon, UsersIcon, TargetIcon, EyeIcon, StethoscopeIcon } from 'lucide-react';
export function AboutUs() {
  return <main className="bg-[#F8F9FA] min-h-screen" data-id="element-84">
      <section className="py-20 bg-[#588157] text-white" data-id="element-85">
        <div className="container mx-auto px-4 text-center" data-id="element-86">
          <h1 className="text-5xl font-serif mb-6" data-id="element-87">About Global Restorative</h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-88">
            A comprehensive healthcare and mental wellness provider dedicated to
            helping individuals and families restore their health, rebuild
            emotional strength, and rediscover purpose.
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-89">
        <div className="container mx-auto px-4" data-id="element-90">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-91">
            <div className="bg-white p-10 rounded-3xl shadow-sm" data-id="element-92">
              <div className="flex items-center gap-4 mb-6" data-id="element-93">
                <TargetIcon className="text-[#588157]" size={32} data-id="element-94" />
                <h2 className="text-3xl font-serif text-[#588157]" data-id="element-95">
                  Our Mission
                </h2>
              </div>
              <p className="text-lg text-[#1A374D]/80 leading-relaxed italic" data-id="element-96">
                "To restore health, promote emotional wellness, and empower
                individuals and families to live healthier, more meaningful, and
                purpose-driven lives."
              </p>
            </div>
            <div className="bg-white p-10 rounded-3xl shadow-sm" data-id="element-97">
              <div className="flex items-center gap-4 mb-6" data-id="element-98">
                <EyeIcon className="text-[#D4A373]" size={32} data-id="element-99" />
                <h2 className="text-3xl font-serif text-[#588157]" data-id="element-100">
                  Our Vision
                </h2>
              </div>
              <p className="text-lg text-[#1A374D]/80 leading-relaxed" data-id="element-101">
                To become a trusted leader in integrated healthcare and mental
                wellness services locally, nationally, and globally.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-id="element-102">
        <div className="container mx-auto px-4" data-id="element-103">
          <h2 className="text-4xl font-serif text-[#588157] text-center mb-16" data-id="element-104">
            Our Core Values
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-6" data-id="element-105">
            {['Compassion', 'Integrity', 'Excellence', 'Confidentiality', 'Professionalism', 'Respect', 'Empowerment'].map(value => <div key={value} className="flex flex-col items-center gap-4 p-6 rounded-2xl bg-[#F8F9FA] text-center" data-id="element-106">
                <div className="w-12 h-12 bg-[#588157] rounded-full flex items-center justify-center text-white" data-id="element-107">
                  <ShieldCheckIcon size={20} data-id="element-108" />
                </div>
                <span className="font-bold text-[#588157] text-xs uppercase tracking-widest" data-id="element-109">
                  {value}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#E2E8E4]" data-id="element-110">
        <div className="container mx-auto px-4" data-id="element-111">
          <h2 className="text-4xl font-serif text-[#588157] text-center mb-16" data-id="element-112">
            Leadership Team
          </h2>
          <div className="grid md:grid-cols-2 gap-12" data-id="element-113">
            <div className="bg-white p-8 rounded-3xl shadow-sm" data-id="element-114">
              <div className="aspect-square rounded-2xl overflow-hidden mb-8 bg-[#588157]/5 flex items-center justify-center text-[#588157]" data-id="element-115">
                <StethoscopeIcon size={120} data-id="element-116" />
              </div>
              <h3 className="text-2xl font-serif text-[#588157] mb-2" data-id="element-117">
                The Founder, NP
              </h3>
              <p className="text-[#D4A373] font-bold uppercase tracking-wider text-sm mb-6" data-id="element-118">
                Clinical Director • 15+ Years Experience
              </p>
              <p className="text-[#1A374D]/70 leading-relaxed" data-id="element-119">
                Expertise in family practice, critical care support, chronic
                disease management, and preventive health across private and
                government hospital systems.
              </p>
            </div>
            <div className="bg-white p-8 rounded-3xl shadow-sm" data-id="element-120">
              <div className="aspect-square rounded-2xl overflow-hidden mb-8" data-id="element-121">
                <img src="https://cdn.magicpatterns.com/uploads/4W8AeqpPoCUqxCLQQwB2TH/WhatsApp-Image-2026-04-24-at-3.36.19-PM.jpg" alt="Joel Osebor" className="w-full h-full object-cover" data-id="element-122" />
              </div>
              <h3 className="text-2xl font-serif text-[#588157] mb-2" data-id="element-123">
                Joel Osebor
              </h3>
              <p className="text-[#D4A373] font-bold uppercase tracking-wider text-sm mb-6" data-id="element-124">
                Co-Founder & Mental Wellness Director
              </p>
              <p className="text-[#1A374D]/70 leading-relaxed" data-id="element-125">
                Specializing in marriage and relationship restoration, trauma
                recovery, and life recovery coaching with over 13 years of
                leadership expertise.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
}